// extracted by mini-css-extract-plugin
export default {"highlightSecondary":"index_highlightSecondary__a8DSI","highlight":"index_highlight__tYXVa"};